import { logos } from '../../assets/logos';
import { Image, Root } from './header.styles';
import config from '../../utils/config';

const brand = config.brandKey;

export function Header() {
    return (
        <Root>
            <Image src={logos[brand]} alt="Logo" />
        </Root>
    );
}
